import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

// import XLSX from 'xlsx';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';

import mainCarg from '../functions/cargos/maincarg';
// "use strict";

//Ajustes
const DetArchivo = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.concepto}</td>
      <td className=''>{elemento.clase}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorAntesDeIVA.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.porcIva.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorIva.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
    </tr>
  )
};

const ListaArchivo = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetArchivo elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmCA extends React.Component {
  state={listaArch: [], totalArch: 0,
        permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleChange = async (ev) => {
    const updState = (listaArch, totalArch) => {
      this.setState({listaArch, totalArch, errors: []})
    };

    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let archcsv = ""
        // console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numDocumentos = 0, linea = 0, listaArch = [], totalArch = 0
          lines.forEach(line => {
            if(line&&(numDocumentos>0||(numDocumentos===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let contrato = campos[0]
              let concepto = campos[1]
              let clase = campos[2]
              let porcIva = 0
              if(campos[4]){
                porcIva = Math.round(campos[4])
              }
              let valorTotal = Math.round(campos[3])
              let valorAntesDeIVA = Math.round(campos[3] / (1 + (porcIva/100)))
              let valorIva = Math.round(valorAntesDeIVA * (1 + (porcIva/100))) - valorAntesDeIVA
              totalArch += valorTotal
              listaArch.push({linea, contrato, concepto, clase, valorAntesDeIVA, porcIva, valorIva, valorTotal})
            }
            numDocumentos += 1
          })
          updState(listaArch, totalArch)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listaArch: [], totalArch: 0, errors: []})
      }
    }
  }

  handleSubmit = async (ev, listaArch)=>{
    let errors = []
    if(listaArch.length===0){
      errors.push({path: "Cargos", message: "No hay cargos"});
    }
    for(let ii=0; ii<listaArch.length; ii++){
      let elemento = listaArch[ii]
      if(!elemento.contrato||!elemento.concepto||!elemento.clase||!elemento.valorAntesDeIVA){
        errors.push({path: "Cargos", message: `Datos inválidos en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}, Concepto: ${elemento.concepto}, Clase: ${elemento.clase}, Valor antes de IVA: ${elemento.valorAntesDeIVA}, % IVA: ${elemento.porcIva}`});
      }

      if(this.props.allClientes.allClientes){
        let {data} = await this.props.allClientes.refetch({contrato: listaArch[ii].contrato, numDocum: 1327})
        let allClientes = await data.allClientes
        if(allClientes.length===0){
          errors.push({path: "Clientes", message: `Contrato NO existe en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
        }
      }

      if(this.props.allClasesServ.allClasesServ){    
        const indexSearch = await this.props.allClasesServ.allClasesServ.findIndex( clase => clase.descrClaseServ === listaArch[ii].clase );
        if(indexSearch===-1){
          errors.push({path: "Clase", message: `Clase NO existe en línea No. ${elemento.linea} => Clase: ${elemento.clase}`});
        }
      }

      if(elemento.valorAntesDeIVA<=0){
        errors.push({path: 'Valor antes de IVA', message: `Línea No. ${elemento.linea} => El valor antes de IVA ($${elemento.valorAntesDeIVA}) no puede ser menor o igual a cero`});
      }

      if(elemento.porcIva<0||elemento.porcIva>100){
        errors.push({path: '% IVA', message: `Línea No. ${elemento.linea} => El % de IVA ($${elemento.porcIva}) es inválido`});
      }
    }

    this.setState({errors})
    if(errors.length===0){
      //PROCESO APLICAR AJUSTES
      document.body.style.cursor = 'wait'

      //EL ULTIMO CONTRATO NO DEBE TENER NAS DE UN AJUSTE PORQUE SI TIENE MAS DE UNO,
      //CUANDO ENCUENTRE EL PRIMER AJUSTE Y LO COMPARE CON contratoFinProc FINALIZA EL PROCESO
      let iii = 0, contratoFinProc = listaArch[listaArch.length-1].contrato, contratoFin = ""

      const startTime = async (listaArch, allCli, createMovCliCCMany) => {
        let clienteSel = {}

        setTimeout(async ()=>{
          // console.log("paso ajuste")
          if(iii<listaArch.length){
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            if(allCli){
              let {data} = await allCli.refetch({contrato: listaArch[iii].contrato, numDocum: 1327})
              let allClientes = await data.allClientes
              clienteSel = allClientes[0]
            }
            contratoFin = await mainCarg(listaArch[iii], clienteSel, createMovCliCCMany, fechaHoraHoy)

            await startTime(listaArch, allCli, createMovCliCCMany)
              // console.log(iii, "contrato ", contratoFin, contratoFinProc)
            if(contratoFin===contratoFinProc){
              
              setTimeout(async () => {
                this.setState({listaArch: [], totalArch: 0, errors: []})
                document.body.style.cursor = 'default'
              }, 2000)

              // console.log("timeout fin", iii)
            }

            iii += 1
          } 
        }, 200);
      }
      await startTime(listaArch, this.props.allClientes, this.props.createMovCliCCMany)
    }
    
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {listaArch, totalArch, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let mensaje = "PROCESAR ARCHIVO"
    let imgIcon = "images/archivo_32.png"

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listaArch):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Procesar archivo de cargos adicionales</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                          <br></br>
                          Columnas en el archivo: Contrato, Concepto, Clase, Valor después de IVA, % IVA
                        </p>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Cargos:&nbsp;
                  {listaArch.length}&nbsp;&nbsp;&nbsp;&nbsp;
                  Valor:&nbsp;
                  ${general.formatNum(totalArch.toString())}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

                <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                    <th className=''>No.</th>  
                    <th className=''>Contrato</th>
                    <th className=''>Concepto</th>
                    <th className=''>Clase</th>
                    <th className='right aligned'>$ Valor antes de IVA</th>
                    <th className='right aligned'>% IVA</th>
                    <th className='right aligned'>$ IVA</th>
                    <th className='right aligned'>$ Valor cargo</th>
                    </tr>
                  </thead>
                  <ListaArchivo list={listaArch}/>
                </table>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allClasesServ, {name:'allClasesServ'}),

  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcAdmCA)
